import { asset } from "@/lib/asset";
import React from 'react';

const TechList = ({ technologies }) => {
    return (
        <section className="w-full bg-white">
            <div className="container mx-auto my-5 px-4">
                <div className="flex flex-wrap justify-start">
                    {technologies.map((card, index) => (
                        <div 
                            key={index}
                            className={`w-full md:w-1/2 lg:w-1/3 xl:w-1/4 my-3 filtered-tex-cards ${index <= 11 ? 'initial-card' : ''}`}
                        >
                            <div 
                                className="w-full rounded-none md:px-[32px] pt-3 pb-5 h-full card-mouseover hover:shadow-lg transition-shadow duration-300"
                                data-bs-recipient={card.target}
                            >
                                <div className="flex flex-wrap ">
                                    {card.image.map((img, imgIndex) => (
                                        <div 
                                            key={imgIndex}
                                            className={`text-center ${card.image.length === 1 ? 'w-full' : 'w-1/3'} mb-3`}
                                        >
                                            <img 
                                                loading="lazy" 
                                                src={asset(`/img/technologies/industries/featured/${img}.png`)}
                                                className="h-20 object-contain w-full" 
                                                alt={card.title}
                                            />
                                        </div>
                                    ))}
                                </div>

                                <div className="text-2xl font-bold text-gray-800 title">
                                    {card.title}
                                </div>
                                <div className="w-full content text-gray-600">
                                    {card.content}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TechList;